import { CaretDownFilled } from '@ant-design/icons';
import type { CSSProperties, MouseEvent } from 'react';

import { Divider, Flex } from '@/components/base';
import GuideTooltip from '@/components/Tooltip/GuideTooltip';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

type Props = {
  status: boolean;
  length: number;
  style?: CSSProperties;
  onActionClick: (e: MouseEvent) => void;
};

const ActionModalGuide = (props: Props) => {
  const color = useColor();
  return (
    <GuideTooltip
      style={{
        ...props.style,
        display: 'flex',
        padding: '0px 12px',
        height: 32,
        gap: 12,
      }}
      status={props.status}
    >
      <Flex a="center">
        <Typo type="label2">
          {props.length}&nbsp;
          <Typo type="label2" color={color.gray500}>
            selected
          </Typo>
        </Typo>
      </Flex>
      <Divider direction="v" backgroundColor={color.gray300} />
      <Flex
        a="center"
        g={6}
        style={{ cursor: 'pointer' }}
        onClick={props.onActionClick}
      >
        <Typo type="label2">Action</Typo>
        <CaretDownFilled />
      </Flex>
    </GuideTooltip>
  );
};

export default ActionModalGuide;
